import { render, staticRenderFns } from "./ShoeCard.vue?vue&type=template&id=3742030c&"
import script from "./ShoeCard.vue?vue&type=script&lang=js&"
export * from "./ShoeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports